import React, { FC } from 'react';

import { Login } from 'common/auth/SignIn/Login';

const LoginPage: FC = () => {
  return <Login />;
};

export default LoginPage;
